import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';

class StatTable extends React.Component {
    renderTableBody(){
        const keys = [
            `${this.props.year}-1`,
            `${this.props.year}-2`,
            `${this.props.year}-3`,
            `${this.props.year}-4`,
            `${this.props.year}-5`,
            `${this.props.year}-6`,
            `${this.props.year}-7`,
            `${this.props.year}-8`,
            `${this.props.year}-9`,
            `${this.props.year}-10`,
            `${this.props.year}-11`,
            `${this.props.year}-12`
        ]
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'Jun',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]

        if (this.props.c1Statistics && this.props.c2Statistics && this.props.c3Statistics){
            return keys.map((key, index) => {
                const getData = (data, statName) => {
                    if(data[key]){
                        return parseInt(data[key][statName]);
                    }else{
                        return 0;
                    }
                }                
                const getStatistic = (statName) => {
                    return getData(this.props.c1Statistics, statName) + getData(this.props.c2Statistics, statName) + getData(this.props.c3Statistics, statName);
                }
                return (<Table.Row key={index}>
                            <Table.Cell>{months[index]}</Table.Cell>
                            <Table.Cell>{getStatistic('premium_accounts')}</Table.Cell>
                            <Table.Cell>{getStatistic('trial_accounts')}</Table.Cell>
                            <Table.Cell>{getStatistic('free_accounts')}</Table.Cell>
                            <Table.Cell>{getStatistic('selling_branches')}</Table.Cell>
                            <Table.Cell>{getStatistic('warehouse_branches')}</Table.Cell>
                            <Table.Cell>{getStatistic('head_office_branches')}</Table.Cell>
                            <Table.Cell>{getStatistic('subscribed')}</Table.Cell>
                            <Table.Cell>{getStatistic('unsubscribed')}</Table.Cell>
                            <Table.Cell>{getStatistic('signups')}</Table.Cell>
                        </Table.Row>)
            })
        }else{
            return <Table.Row><Table.Cell>Fetching data...</Table.Cell></Table.Row>
        }
    }
    render() {
        return (
            <Table style={{fontSize: '12px'}}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell rowSpan='2'>Month</Table.HeaderCell>
                        <Table.HeaderCell colSpan='3'>Accounts</Table.HeaderCell>
                        <Table.HeaderCell colSpan='3'>Branches</Table.HeaderCell>
                        <Table.HeaderCell colSpan='2'>Subscriptions</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='2'>Signups</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell>Premium</Table.HeaderCell>
                        <Table.HeaderCell>Trial</Table.HeaderCell>
                        <Table.HeaderCell>Free</Table.HeaderCell>
                        <Table.HeaderCell>Selling</Table.HeaderCell>
                        <Table.HeaderCell>Warehouse</Table.HeaderCell>
                        <Table.HeaderCell>Head Office</Table.HeaderCell>
                        <Table.HeaderCell>Subscribed</Table.HeaderCell>
                        <Table.HeaderCell>Unsubscribed</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {this.renderTableBody()}
                </Table.Body>
            </Table>
                )
    }
}

const mapStateToProps = (state) => {
    return { 
        year: state.dashboard.year,
        c1Statistics: state.dashboard.c1Statistics,
        c2Statistics: state.dashboard.c2Statistics,
        c3Statistics: state.dashboard.c3Statistics,
     };
}

export default connect(mapStateToProps)(StatTable);